import { render, staticRenderFns } from "./Healingcenter.vue?vue&type=template&id=1807d2fb&"
import script from "./Healingcenter.vue?vue&type=script&lang=js&"
export * from "./Healingcenter.vue?vue&type=script&lang=js&"
import style0 from "./Healingcenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports